<template>
  <app-layout>

    <create-room></create-room>
  </app-layout>
</template>

<script>

import AppLayout from "@/Layouts/AppLayout";
import CreateRoom from "@/Pages/PlanningPoker/CreateRoom";


export default {
  components: {
    CreateRoom,
    AppLayout,
  },
};
</script>
